module.exports = __webpack_public_path__ + "static/customize_3-b7c9f43cdbfa6d85726aff48d60eb063.png";